export type TrendInterval = "year" | "quarter" | "month" | "rollingYear" | "dynamic";
export const allowedTrendIntervalUrlList: TrendInterval[] = [
    "year",
    "quarter",
    "month",
    "rollingYear",
    "dynamic",
];
export const defaultTrendInterval: TrendInterval = "year";
